<template>
    <div class="container">
        <!-- <div style="font-size:26px; font-weight:700;">{{clueTitle}}</div> -->
        <div class="media_title">지식인</div>

        <div class="kin_contents">
            <div v-html="clueContents.kin_logo" style="margin-bottom:10px;"></div>
            <div>
                <img src="../assets/img/kin_q.png" width="49" />
                <span v-html="clueTitle" style="font-size:20px; font-weight:700; margin-left:10px;"></span>
            </div>
            <div v-html="clueContents.text_q" style="font-size:18px; line-height:1.5; margin-bottom:10px;"></div>
            
            <div class="under_line">
                <img src="../assets/img/profile_img.png" width="30" style="margin-right:10px;">
                <span v-html="clueContents.user_name_q" style="margin-right:10px; font-size:18px;"></span>
                <span v-html="clueContents.date" style="font-size:18px;"></span>
            </div>

            <div style="font-size:20px;">
                <img src="../assets/img/profile_img.png" width="46" style="margin-right:10px;">
                <span v-html="clueContents.user_name_a" style="margin-right:10px;"></span>님 답변
            </div>
            <div v-html="clueContents.text_a" style="font-size:18px; line-height:1.8;"></div>
            
            <!-- 지금은 포함된 이미지가 없음 -->
            <!-- <div v-html="clueContents.image_a" style="margin:10px;"></div> -->
        </div>
    </div>
</template>

<script>
export default {
    name: 'ClueKinComp',

    props: {
        clueTitle: String,
        clueContents: Object,
    },

    mounted() {
        console.log(this.clueContents)

        // v-html로 표시한 것은 data binding 등이 되지 않아 event listener를 따로 등록함
        const highlights = document.getElementsByClassName('highlight')
        for(let light of highlights) {
            light.addEventListener('click', this.touchElement)
        }
    },

    methods: {
        touchElement: function(event) {
            // TODO 이건 모달에서 처리하자
            // this.initItemCategoryModal()
            // this.initItemTrueFalseModal()

            // 이미지를 눌렀을 때
            if(event.target.nodeName == 'IMG') {
                console.log(event.target.nodeName)
                console.log(event.target.attributes)
                console.log(event.target.attributes.src)

                // TODO 여기 이미지에 대해서 더 작업할 부분 있음

                // this.selectedPart = event.target
                // this.modalVisible = true
            }

            // 텍스트를 눌렀을 때
            else {
                this.$emit('touchElement', event.target)
            }
        },
    }
}
</script>

<style scoped>


/* pc */
@media screen and (min-width: 415px) {
    .container {
        overflow: hidden;
        font-size:20px;
        padding:5px 20px;
        margin:10px 0px;
        width:417px;
        height: 470px;
        background-repeat: no-repeat;
        background-image:url("../assets/img/clue_bg.png");
        /* 첫 번째 값: 이미지 너비, 두 번째 값: 이미지 높이 */
        background-size: 417px 470px;
    }
    .media_title {
        text-align:center;
        margin-bottom:20px;
        font-size:20px;
        font-weight:700;
    }
    .kin_contents {
        overflow:auto;
        height:380px;
    }
    .image {
        width: 360px;
    }
}


/* mobile */
@media screen and (max-width: 414px) {
    .container {
        overflow: hidden;
        font-size: 20px;
        padding: 5px 20px;
        margin: 10px auto;
        width: 343px;
        height: 375px;
        background-repeat: no-repeat;
        background-image:url("../assets/img/clue_bg_mobile.png");
        /* 첫 번째 값: 이미지 너비, 두 번째 값: 이미지 높이 */
        background-size: 343px 375px;
    }
    .media_title {
        margin-left: -10px;
        margin-bottom:20px;
        font-size: 20px;
        font-weight: 700;
    }
    .kin_contents {
        overflow: auto;
        height: 300px;
    }
    .image {
        width: 300px;
    }
}



.under_line {
    margin-bottom: 20px;
    border-bottom:1px solid black;
    padding-bottom:10px;
}
</style>
